declare namespace $ {

	type $shm_list_head__title_shm_dashboard_admin_users_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_list_head['title'] >
	>
	type $shm_list_head__filter_shm_dashboard_admin_users_2 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_users['filter'] >
		,
		ReturnType< $shm_list_head['filter'] >
	>
	type $shm_list_head__add_shm_dashboard_admin_users_3 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_users['user_add'] >
		,
		ReturnType< $shm_list_head['add'] >
	>
	type $shm_list_head__Close_shm_dashboard_admin_users_4 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_list_head['Close'] >
	>
	type $shm_list_head__Settings_shm_dashboard_admin_users_5 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_list_head['Settings'] >
	>
	type $mol_list__rows_shm_dashboard_admin_users_6 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_users['body_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_dashboard_admin_users_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_users_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_users_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_users_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_users_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_users_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_users_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_users_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_dashboard_admin_users_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__head_shm_dashboard_admin_users_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['head'] >
	>
	type $mol_page__body_shm_dashboard_admin_users_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_dashboard_admin_user_add__created_shm_dashboard_admin_users_18 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_users['user_created'] >
		,
		ReturnType< $shm_dashboard_admin_user_add['created'] >
	>
	type $shm_dashboard_admin_user_dashboards__user_id_shm_dashboard_admin_users_19 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_users['selected_user_id'] >
		,
		ReturnType< $shm_dashboard_admin_user_dashboards['user_id'] >
	>
	type $shm_dashboard_admin_user_dashboards__User_label_shm_dashboard_admin_users_20 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_dashboard_admin_user_dashboards['User_label'] >
	>
	type $mol_view__sub_shm_dashboard_admin_users_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_dashboard_admin_users_row__current_shm_dashboard_admin_users_22 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_users['user_current'] >
		,
		ReturnType< $shm_dashboard_admin_users_row['current'] >
	>
	type $shm_dashboard_admin_users_row__click_shm_dashboard_admin_users_23 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_users['user_pick'] >
		,
		ReturnType< $shm_dashboard_admin_users_row['click'] >
	>
	type $shm_dashboard_admin_users_row__sub_shm_dashboard_admin_users_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_dashboard_admin_users_row['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_users_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_dashboard_admin_users extends $mol_book2 {
		user_pages( ): readonly(any)[]
		filter( next?: string ): string
		user_add( next?: any ): any
		List_head( ): $shm_list_head
		body_rows( ): readonly(any)[]
		Rows( ): $mol_list
		user_created( next?: string ): string
		selected_user_id( next?: string ): string
		Table_head_email( ): $mol_view
		Table_head_name( ): $mol_view
		Table_head_created( ): $mol_view
		Table_head_id( ): $mol_view
		user_current( id: any): boolean
		user_pick( id: any, next?: any ): any
		user_email( id: any): string
		Email( id: any): $mol_view
		user_name( id: any): string
		Name( id: any): $mol_view
		user_created_at( id: any): string
		Created( id: any): $mol_view
		user_id( id: any): string
		Id( id: any): $mol_view
		empty_message( ): string
		add_opened( next?: boolean ): boolean
		placeholders( ): readonly(any)[]
		pages( ): ReturnType< $shm_dashboard_admin_users['user_pages'] >
		Users_page( ): $mol_page
		User_add( ): $shm_dashboard_admin_user_add
		Dashboards( ): $shm_dashboard_admin_user_dashboards
		Table_head( ): $mol_view
		Row( id: any): $shm_dashboard_admin_users_row
		Empty( ): $mol_view
	}
	
	export class $shm_dashboard_admin_users_row extends $mol_button_minor {
		current( ): boolean
		attr( ): ({ 
			'shm_dashboard_admin_users_row_current': ReturnType< $shm_dashboard_admin_users_row['current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
	}
	
}

//# sourceMappingURL=users.view.tree.d.ts.map